// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.ce-brand {
  background-color: var(--ce-grey-4);
  text-align: center;
  padding: var(--ce-base-padding-large);
  color: var(--ce-grey-55);
  display: flex;
  justify-content: center;
  align-items: center;
}

.white-labelled header.ce-brand {
  padding: 12px 10px 16px 10px;
}

header.ce-brand .ce-brand-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  line-height: 1.3;
  gap: 5px;
}

header.ce-brand a {
  color: var(--ce-white);
  text-decoration: none;
}

header.ce-brand .project-hosting {
  margin-right: 10px;
}

header.ce-brand .ce-brand-logo {
  vertical-align: middle;
  margin: 0 10px 0 0;
}
header .ce-brand-logo svg {
  max-width: 100%;
  width: auto;
  fill: var(--ce-grey-55);
}
.white-labelled header.ce-brand .ce-brand-logo svg {
  height: 20px;
  opacity: .9;
}

@media (max-width: 767px) {
  header.ce-brand {
    padding: 10px;
  }

  header.ce-brand .ce-brand-content {
    font-size: var(--ce-body-small);
    justify-content: center;
    flex-wrap: wrap;
    line-height: 1.3;
    gap: 3px;
  }

  .white-labelled header.ce-brand .ce-brand-logo svg {
    height: 18px;
  }
}


@media (max-width: 575px) {
  header.ce-brand a {
    display:flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/LoginHeader.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;AACF;;;AAGA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF","sourcesContent":["header.ce-brand {\n  background-color: var(--ce-grey-4);\n  text-align: center;\n  padding: var(--ce-base-padding-large);\n  color: var(--ce-grey-55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.white-labelled header.ce-brand {\n  padding: 12px 10px 16px 10px;\n}\n\nheader.ce-brand .ce-brand-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  line-height: 1.3;\n  gap: 5px;\n}\n\nheader.ce-brand a {\n  color: var(--ce-white);\n  text-decoration: none;\n}\n\nheader.ce-brand .project-hosting {\n  margin-right: 10px;\n}\n\nheader.ce-brand .ce-brand-logo {\n  vertical-align: middle;\n  margin: 0 10px 0 0;\n}\nheader .ce-brand-logo svg {\n  max-width: 100%;\n  width: auto;\n  fill: var(--ce-grey-55);\n}\n.white-labelled header.ce-brand .ce-brand-logo svg {\n  height: 20px;\n  opacity: .9;\n}\n\n@media (max-width: 767px) {\n  header.ce-brand {\n    padding: 10px;\n  }\n\n  header.ce-brand .ce-brand-content {\n    font-size: var(--ce-body-small);\n    justify-content: center;\n    flex-wrap: wrap;\n    line-height: 1.3;\n    gap: 3px;\n  }\n\n  .white-labelled header.ce-brand .ce-brand-logo svg {\n    height: 18px;\n  }\n}\n\n\n@media (max-width: 575px) {\n  header.ce-brand a {\n    display:flex;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
